<template>
  <div>
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['info']" mode="horizontal">
        <a-menu-item key="info">
          <a-icon type="file-text"/>
          型录锚点
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button @click="()=>{$router.go(-1)}">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
      <div class="border-content">
        <div class="middle-content">
          <div class="left-poster">
            <a-popconfirm
              class="popconfirm"
              id="popconfirm"
              title="确定要向该点放置?"
              :visible="popconfirmVisible"
              ok-text="Yes"
              cancel-text="No"
              @confirm="confirm"
              @cancel="cancel">
            </a-popconfirm>
            <img
              @click="getMouseXY($event)"
              slot="cover"
              ref="img"
              alt="image"
              class="cover-img"
              :src="form.data.mediaUrl"/>
            <div v-for="item in pointTable.data" :key="item.id" class="over-point">
              <div :style="calcStylePoint(item)" v-if="item.position === 'right'">
                <div class="point-item"></div>
                <span class="point-span right-pos">
              <span class="font-span">{{ item.goodsName }}</span>
              <img src="../../../assets/arrow.png"/>
              </span>

              </div>
              <div v-if="item.position === 'left'" :style="calcStylePoint(item)">
              <span class="point-span left-pos">
                  <span class="font-span-left">{{ item.goodsName }}</span>
                  <img src="../../../assets/arrow.png"/>
              </span>
                <div class="point-item-left"></div>
              </div>
            </div>
          </div>
          <div class="right-table">
            <a-card :title="'锚点数据'" style="margin-left:20px; ">
              <a-table :data-source="pointTable.data" row-key="id">
                <a slot="name" slot-scope="text">{{ text }}</a>
                <a-table-column
                  data-index="goods"
                  align='center'
                  title="商品图"
                  width="120">
                  <template slot-scope="record">
                    <a-avatar :src="record ? record.mediaUrl: ''"></a-avatar>
                  </template>
                </a-table-column>
                <a-table-column
                  data-index="offsetxPer"
                  title="描点X位置"
                  align='center'
                  width="120">
                </a-table-column>
                <a-table-column
                  data-index="position"
                  title="方向"
                  align='center'>
                </a-table-column>
                <a-table-column
                  data-index="offsetyPer"
                  title="描点Y位置"
                  width="120"/>
                <a-table-column
                  data-index="date"
                  :title="$t('OPERATION')||'操作'">
                  <template slot-scope="text, record">
                    <a-button
                      type="link"
                      @click="deleteLookBookPoint(record.id)">{{ $t('REMOVE') || '删除' }}
                    </a-button>
                  </template>
                </a-table-column>
              </a-table>
            </a-card>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      :visible="goodsSelectForm.visible"
      title="商品选择"
      width="60%"
      :destroyOnClose="true"
      @ok="handleGoodsSelectOk"
      @cancel="handleGoodsSelectCancel">
      <a-form-model :model="currentDiv" :rules="rules" ref="posterPointForm">
        <a-form-model-item label="锚点位置" prop="position">
          <a-select v-model="currentDiv.position">
            <a-select-option key="1" value="left">左侧</a-select-option>
            <a-select-option key="2" value="right">右侧</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="商品选择" prop="goodsId">
          <img-website-goods-select
            @sumbitName="getGoodName"
            :goods-ids="pointTable.goodsIds"
            v-model="currentDiv.goodsId">
          </img-website-goods-select>
        </a-form-model-item>

      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  _queryGoodsInstagram,
} from '@/api/websiteGoodsInstagramApi.js';
import {
  _queryInstagramPoints,
  _deleteInstagramPoints,
  _addInstagramPoints
} from '@/api/websiteGoodsInstagramPointsApi.js';
import ImgWebsiteGoodsSelect from '../../../components/ImgWebsiteGoodsSelect.vue';

function editLotteryActivityConfig(record) {
  this.configForm.data.shopAddressId = record.shopAddressId;
  this.configForm.visible = true;
}

function closeForm() {
  this.configForm.visible = false;
}

async function getInstagramInfo() {
  const result = await _queryGoodsInstagram(this.instagramId);
  if (result) {
    this.form.data.mediaUrl = result.mediaUrl;
    await this.getPointsList();
  }
}

function getMouseXY(e) {
  const offsetX = e.offsetX
  const offsetY = e.offsetY
  const PicWith = e.target.offsetWidth
  const PicHeight = e.target.offsetHeight
  const posxper = (offsetX / PicWith).toFixed(2)
  const posyper = (offsetY / PicHeight).toFixed(2)
  const divName = 'marker' + posxper + '-' + posyper
  this.createDivDom(posxper, posyper, divName, 'right')
  // document.getElementById('left-poster').appendChild(div)

  this.currentDiv.posPertange = []
  this.currentDiv.posPertange.push(posxper, posyper)
  var popConfrimDiv = document.getElementById('popconfirm')
  popConfrimDiv.style.top = offsetY + 'px'
  popConfrimDiv.style.left = offsetX + 'px'
  popConfrimDiv.style.position = 'absolute'
  this.popconfirmVisible = true
}

function upSeriesPosition() {
  this.lookBookPositionForm.visible = true
}

function handleGoodsSelectCancel() {
  this.goodsSelectForm.visible = false;
  this.getPointsList();
}

async function getPointsList() {
  if (this.instagramId && this.form.data.mediaUrl) {
    const result = await _queryInstagramPoints(this.instagramId);
    console.log(result)
    if (result) {
      this.pointTable.data = result
      this.pointTable.goodsIds = result.map(x => x.goodsId)
      this.coverImg.width = this.$refs.img.width
      this.coverImg.height = this.$refs.img.height
      this.$forceUpdate()
    }
  }
}

function getGoodName(val) {
  this.currentDiv.goodsName = val
}

async function deleteLookBookPoint(relationId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteInstagramPoints(relationId);
      if (result) {
        this.$message.success('删除成功');
        await this.getPointsList();
      }
    },
  });
}

function calcStylePoint(item) {
  const style = {}
  style.position = 'absolute'
  style.display = 'flex'
  style.height = 30 + 'px'
  style.alignItems = 'center'

  style.top = (375 * parseFloat(item.offsetyPer) - 15) + 'px'
  if (item.position === 'right') {
    style.left = 375 * parseFloat(item.offsetxPer) + 'px'
  } else {
    style.right = (375 - 375 * parseFloat(item.offsetxPer)) + 'px'
  }
  return style
}

function calcStyleLine(item) {
  const style = {}
  style.position = 'relative'
  style.height = 30 + 'px'
  style.maxWidth = 141 + 'px'

  if (item.position === 'left') {
    style.right = 10 + 'px'
  } else {
    style.left = 10 + 'px'
    style.paddingLeft = 10 + 'px'
  }
  return style
}

function createDivDom(offsetX, offsetY, markerName, goodsName, position) {
  const templateDiv = {
    position: 'left',
    offsetyPer: offsetY,
    offsetxPer: offsetX,
    goodsName: '锚点位置',
    id: offsetX + '-' + offsetY,
    mediaUrl: ''
  }
  this.pointTable.data.push(templateDiv)
}

async function handleGoodsSelectOk() {
  const result = await _addInstagramPoints(this.instagramId, {
    goodsId: this.currentDiv.goodsId,
    offsetxPer: this.currentDiv.posPertange[0],
    offsetyPer: this.currentDiv.posPertange[1],
    position: this.currentDiv.position,
    goodsName: this.currentDiv.goodsName,
  })
  if (result) {
    this.goodsSelectForm.visible = false
    this.$message.info('标记添加成功')
    await this.getPointsList()
  }
}

export default {
  name: 'InstagramPositions',
  components: {
    ImgWebsiteGoodsSelect,
  },
  props: {
    instagramId: String,
  },
  data() {
    return {
      goodsSelectForm: {
        visible: false,
      },
      currentDiv: {
        elementObj: null,
        posPertange: [],
        goodsId: '',
        goodsName: '',
        position: 'left',
      },
      rules: {
        position: [{ required: true, trigger: 'blur' }],
        goodsId: [{ required: true, trigger: 'blur' }],
      },
      popconfirmVisible: false,

      coverImg: {
        width: 0,
        height: 0,
      },
      // 已存在的标签Id
      posDivIdList: [],
      form: {
        data: {
          name: '',
          mediaUrl: '',
          nameEn: '',
          description: '',
        },
        visible: false,
      },
      pointTable: {
        data: [],
        goodsIds: [],
      },
    };
  },
  methods: {
    closeForm,
    editLotteryActivityConfig,
    upSeriesPosition,
    getInstagramInfo,
    handleGoodsSelectOk,
    handleGoodsSelectCancel,
    getPointsList,
    createDivDom,
    getMouseXY,
    deleteLookBookPoint,
    getGoodName,
    calcStylePoint,
    calcStyleLine,
    confirm() {
      this.popconfirmVisible = false
      this.goodsSelectForm.visible = true
    },
    cancel() {
      this.popconfirmVisible = false
      this.getPointsList()
    }
  },
  async created() {
    if (this.instagramId) {
      await this.getInstagramInfo();
    }
  },
};
</script>

<style lang="less" scoped>

.popconfirm {
  position: absolute;
  left: 200px;
  top: 200px;
}

.middle-content {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.left-poster {
  width: 375px;
  height: 375px;
  overflow: hidden;
  box-sizing: content-box;
  position: relative;

  .cover-img {
    width: 100%;
    object-fit: cover;
  }

}

.point-line {
  .font-div-left {
    font-size: 10px;
    font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 30px;
    padding-left: 10px;
  }

  .font-div-right {
    font-size: 10px;
    font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 30px;
    padding-left: 10px;

  }

}

.point-item {
  width: 4px;
  height: 5px;
  display: inline-block;
  background-color: white;

}

.font-span {
  display: inline-block;
  white-space: nowrap;
  font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
  color: #fff;
  height: 11px;
  line-height: 100%;
  font-size: 10px;
  margin-left: 10px;
  font-size: 10px;

}

.font-span-left {
  display: inline-block;
  white-space: nowrap;
  font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
  color: #fff;
  height: 11px;
  margin-left: 10px;
  line-height: 11px;

  font-size: 10px;

}

.point-item-left {
  margin-left: 10px;
  width: 4px;
  height: 5px;
  display: inline-block;
  background-color: white;

}

.right-table {
  width: calc(100% - 450px);

}

.point-span {

  clip-path: polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%);
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 13px;

  img {
    width: 11px;
    height: 3px;
    margin-left: 19px;
    color: #fff;

  }

}

.right-pos {
  margin-left: 5px;
}

.left-pos {
  margin-right: 5px;
}

</style>
